import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/api";

export const SiteFooter = ({ delay = 2 }) => (
  <motion.footer
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.8, delay }}
    className="pb-6 flex flex-col items-center gap-3"
  >
    <div className="flex items-center gap-2 flex-wrap justify-center">
      <a
        href={SITE.instagram}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-instagram-link"
        className="glass rounded-full px-4 py-2 flex items-center gap-2 text-white/80 hover:text-white text-xs font-body transition-colors"
      >
        <Instagram className="w-3.5 h-3.5" strokeWidth={1.6} />
        {SITE.instagramHandle}
      </a>
      <a
        href={SITE.whatsappChannel}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="footer-whatsapp-link"
        className="glass rounded-full px-4 py-2 flex items-center gap-2 text-white/80 hover:text-white text-xs font-body transition-colors"
      >
        <MessageCircle className="w-3.5 h-3.5" strokeWidth={1.6} />
        Canale WhatsApp
      </a>
    </div>
    <div className="flex items-center gap-3 text-[11px] text-white/40 font-body">
      <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white/70 transition-colors">Privacy</Link>
      <span>·</span>
      <Link to="/cookie" data-testid="footer-cookie-link" className="hover:text-white/70 transition-colors">Cookie</Link>
      <span>·</span>
      <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white/70 transition-colors">Area riservata</Link>
    </div>
  </motion.footer>
);
